var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8C1 4.13401 4.13401 1 8 1H32C35.866 1 39 4.13401 39 8V32C39 35.866 35.866 39 32 39H8C4.13401 39 1 35.866 1 32V8Z",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5870_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9811 11.4837V14.7313H19.0502C19.2921 14.1785 19.5684 13.6948 19.9485 13.2111C20.3285 12.762 20.7777 12.3474 21.2613 12.0365C21.745 11.7255 22.2978 11.4491 22.8506 11.2764C23.4034 11.1036 23.9907 11 24.6126 11C24.9235 11 25.269 11.0691 25.6491 11.1727V15.6296C25.4072 15.595 25.1654 15.5605 24.8199 15.5259C24.5089 15.4914 24.198 15.4914 23.9216 15.4914C23.0579 15.4914 22.2978 15.6296 21.6759 15.9405C21.054 16.2169 20.5704 16.6315 20.1903 17.1497C19.8103 17.6679 19.5684 18.2553 19.3957 18.9117C19.223 19.6027 19.1539 20.3282 19.1539 21.1228V29H14.3516V11.4837H18.9811Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5870_7865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2975,
    height: 18,
    fill: "white",
    transform: "translate(14.3516 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a4c79089598866ec6043d72a5e76bf3b.svg";
export { ForwardRef as ReactComponent };